import React from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';

import { DATE_TIME_FORMAT } from '../../constants';

const CreditList = ({
  credits = [],
  isCreditsForAppling = false,
  pushCredit,
}) => (
  <div>
    <table className="table">
      <thead>
        <tr>
          <th>ID</th>
          <th>Credit Type</th>
          <th>Credit Owed</th>
          <th>Credit Applied</th>
          <th>Monthly</th>
          <th>Date Created</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {credits.length > 0 &&
          credits.map((credit) => (
            <tr key={credit.id}>
              <td>{credit.id}</td>
              <td>{credit.credit_type}</td>
              <td>{credit.credit_owed}</td>
              <td>{credit.credit_applied}</td>
              <td>{credit.monthly}</td>
              <td>{moment(credit.date_created).format(DATE_TIME_FORMAT)}</td>
              {isCreditsForAppling ? (
                <td>
                  <label htmlFor={credit.id}>
                    <input
                      type="checkbox"
                      id={credit.id}
                      onChange={({ target }) => {
                        const { checked } = target;
                        pushCredit(credit.id, checked);
                      }}
                    />
                  </label>
                </td>
              ) : (
                <td>
                  <Link to={`/credits/${credit.id}/view`}>View</Link>
                </td>
              )}
            </tr>
          ))}
        {credits.length === 0 ? (
          <tr>
            <td colSpan="6">No credits</td>
          </tr>
        ) : null}
      </tbody>
    </table>
  </div>
);

export default CreditList;
